import * as cx from 'classnames';
import { getInlinedImages, linebreaksbr, mentionize, replaceImageMarks, urlize } from 'mk/bazaar/common/filters';
import { user_profile_url } from 'mk/urls/functions';
import { ExperienceEntity } from 'mk2/apps/wiki/schemas';
import AvatarImg from 'mk2/components/AvatarImg';
import { timeAt } from 'mk2/helpers/timeformat';
import * as React from 'react';
import styles from './ExperienceHeader.mscss';

interface OwnProps {
    className?: string;
    experience: ExperienceEntity;
}

type Props = OwnProps;

export default class ExperienceHeader extends React.Component<Props> {

    public render() {
        const { className, experience} = this.props;

        return (
            <div className={cx(styles.ExperienceHeader, className)}>
                <AvatarImg
                    size={18}
                    user={experience.authorUser}
                    href={user_profile_url(experience.authorUser.username)}
                />

                <a
                    className={styles.ExperienceHeader__author}
                    href={user_profile_url(experience.authorUser.username)}
                >
                    {experience.authorUser.username}
                </a>

                <div key="created-sep" className={styles.ExperienceHeader__sep}>•</div>
                <span key="created">
                    {timeAt(experience.created)}
                </span>
            </div>
        );
    }
}
